<mat-toolbar color="primary">
  <a href="https://www.cara.ch">
    <img src="./assets/images/logo.svg" alt="CARA" />
  </a>
  <span
    *ngIf="title | translate as translatedTitle"
    class="title text-truncated"
    [title]="translatedTitle"
  >
    {{ translatedTitle }}
  </span>
  <ul class="languages-list">
    <li *ngFor="let language of supportedLanguages">
      <button
        mat-button
        (click)="changeLanguage(language)"
        [matTooltip]="language.displayName"
        [class.selected]="currentLang === language.code"
      >
        {{ language.code | uppercase }}
      </button>
    </li>
  </ul>
  <div class="user-info" *ngIf="(user$ | async) as user">
    <span class="user-name">
      {{ user.firstName }} {{ user.lastName | slice:0:1 }}. ({{ 'identity-provider.' + user.identityProvider | translate }})
    </span>
    <button
      mat-mini-fab
      (click)="logout()"
      [matTooltip]="'actions.log-out' | translate"
    >
      <mat-icon>logout</mat-icon>
    </button>
  </div>
</mat-toolbar>
<div class="page-content">
  <router-outlet></router-outlet>
</div>
